import React from 'react';
import { useTranslate } from '@/locale';
import { csChatBuilder } from '@/utils/helper';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface Props {
  textStyle?: CSSProperties;
  linkStyle?: CSSProperties;
}

export const ContactLifepackCare = ({
  textStyle,
  linkStyle,
}: Props): JSX.Element => {
  const { translate } = useTranslate();

  return (
    <div className="need-help" data-testid="need-help">
      <p
        style={{
          marginTop: '20px',
        }}
      >
        <span className="text-disabled" style={textStyle}>
          {translate('needHelp')}
        </span>
        <a
          href={csChatBuilder()}
          className="link"
          target="_blank"
          rel="noreferrer"
          style={linkStyle}
        >
          {translate('contactLifepackCare')}
        </a>
      </p>
    </div>
  );
};
